export interface Params {
  deviceId?: string;
  deviceType?: string;
  screenManufacturer?: string;
  screenModel?: string;
  screenSerialNumber?: string;
  screenOsVersion?: string;
  accessToken?: string;
  offlineSupport?: boolean;
  debug?: boolean;
  hostVersion?: string;
  macAddress?: string;
  version?: string;
}

// Get params from query string. Only set these when you want to override the defaults.
// This should only be used for debugging.
//   ie. https://secondscreen.raydiant.com?deviceId=...&accessToken=...&version=0.1.0&debug=true
export default function getParams(): Params {
  const searchParams = new URLSearchParams(window.location.search);
  const params: Params = {};

  const deviceIdSearchParam = searchParams.get('deviceId');
  if (deviceIdSearchParam) {
    params.deviceId = deviceIdSearchParam;
  }

  const deviceTypeParam = searchParams.get('deviceType');
  if (deviceTypeParam) {
    params.deviceType = deviceTypeParam;
  }

  const screenManufacturerParam = searchParams.get('screenManufacturer');
  if (screenManufacturerParam) {
    params.screenManufacturer = screenManufacturerParam;
  }

  const screenModelParam = searchParams.get('screenModel');
  if (screenModelParam) {
    params.screenModel = screenModelParam;
  }

  const screenSerialNumberParam = searchParams.get('screenSerialNumber');
  if (screenSerialNumberParam) {
    params.screenSerialNumber = screenSerialNumberParam;
  }

  const screenOsVersionParam = searchParams.get('screenOsVersion');
  if (screenOsVersionParam) {
    params.screenOsVersion = screenOsVersionParam;
  }

  const macAddress = searchParams.get('macAddress');
  if (macAddress) {
    params.macAddress = macAddress;
  }

  const accessTokenSearchParam = searchParams.get('accessToken');
  if (accessTokenSearchParam) {
    params.accessToken = accessTokenSearchParam;
  }

  const offlineSupportParam = searchParams.get('offlineSupport');
  if (offlineSupportParam) {
    params.offlineSupport = offlineSupportParam === 'true';
  }

  const debugSearchParam = searchParams.get('debug');
  if (debugSearchParam) {
    params.debug = debugSearchParam === 'true';
  }

  const hostVersionSearchParam = searchParams.get('hostVersion');
  if (hostVersionSearchParam) {
    params.hostVersion = hostVersionSearchParam;
  }

  const versionSearchParam = searchParams.get('version');
  if (versionSearchParam) {
    params.version = versionSearchParam;
  }

  return params;
}
